import request from '@/utils/request'

/**
 * POST 方法 与 GET方法  区别
 *
 * post==> data: obj
 * get==>params: obj
 *
 */

 export function getCjScore(obj: any) {
  return request({
    url: '/getDisassembleScore',
    method: 'get',
    params: obj,
  })
}

